export const SHOW_PUBLICITY = 'SHOW_PUBLICITY';
export const HIDE_PUBLICITY = 'HIDE_PUBLICITY';
